import { useMemo } from 'react';
import type { FormField } from '@elfsight/widget-form-builder/widget';
import { useFormSelector } from '@elfsight/widget-form-builder/widget';
import { PAYMENT_EMAIL_FIELD } from '../../../common';

export function useCustomerEmail(derivedEmailFieldId?: string): {
  field: FormField;
  initialValue: string;
} {
  const { fields } = useFormSelector();

  return useMemo(() => {
    const emailFieldId = derivedEmailFieldId ?? PAYMENT_EMAIL_FIELD.id;
    const emailField = fields[emailFieldId];

    let initialValue = '';

    if (typeof emailField?.value === 'string') {
      initialValue = emailField?.value;
    }

    return {
      field: { ...PAYMENT_EMAIL_FIELD, id: emailFieldId },
      initialValue
    };
  }, [derivedEmailFieldId]);
}
